import React from 'react';
import { useLocation } from 'react-router-dom';
import BrandLogo from '@/components/brand/BrandLogo';
import { isMemberAppPath } from '@/config/hosts';

function hideOn(pathname) {
  if (pathname === '/' || pathname === '/for-hospitals') return true;
  if (pathname === '/talk' || pathname === '/platform' || pathname === '/specialday') return true;
  if (isMemberAppPath(pathname)) return true;
  if (pathname.startsWith('/cancer')) return true;
  if (pathname.startsWith('/find-hospitals') || pathname.startsWith('/find-oncologists')) return true;
  if (pathname.startsWith('/treatment-options')) return true;
  if (pathname.startsWith('/cost-calculator') || pathname === '/cost') return true;
  if (pathname.startsWith('/rare-cancers')) return true;
  if (pathname.startsWith('/teleconsultation')) return true;
  if (pathname.startsWith('/second-opinion')) return true;
  if (pathname.startsWith('/journey-builder') || pathname === '/get-started') return true;
  if (pathname.startsWith('/get-matched')) return true;
  if (pathname.startsWith('/oncoagent')) return true;
  return false;
}

export default function HomeLogo() {
  const { pathname } = useLocation();
  if (hideOn(pathname)) return null;

  const cleanPath = (pathname || '').replace(/\/+$/, '') || '/';
  const isAuthPage =
    cleanPath === '/authentication' ||
    cleanPath === '/login' ||
    cleanPath === '/register' ||
    cleanPath === '/reset-password';

  return (
    <BrandLogo
      className={`home-logo ${isAuthPage ? 'home-logo--transparent' : ''}`}
      testId="home-logo"
      size="md"
    />
  );
}
